module.exports = __webpack_public_path__ + "static/img/18.2d62db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/18.png
// module id = eqeR
// module chunks = 4